module.exports = __webpack_public_path__ + "img/ztzl.13099917.svg";